module.exports = __webpack_public_path__ + "static/media/tech-assess-1.98ea1af8.png";